"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// utils

/* ++++++++++ --------------- LINK : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'Link',
  group: _definitionhelpers.groupNames.ctas,
  props: {
    name: {
      type: 'string',
      default: 'calltoaction'
    },
    type: {
      type: 'string',
      default: 'external',
      options: ['external', 'internal', 'scroll', 'action', 'action_route', 'modal', 'email']
    },
    variant: {
      type: 'string',
      default: 'primary',
      options: ['primary', 'secondary', 'normal', 'system', 'disabled', 'action', 'delete', 'combination', 'control']
    },
    color: {
      type: 'string',
      // default: 'primary',
      options: ['primary', 'secondary', 'supporting', 'accent', 'compliment', 'warning', 'error', 'attention', 'neutral', 'light', 'dark', 'grey', 'system']
    },
    text: {
      type: 'string',
      default: 'Call to Action'
    },
    icon: {
      type: 'string',
      default: 'arrow-circle-right',
      help: {
        title: 'fontawesome library',
        desc: 'We use this external library of font icons throughout our products. Copy and paste an icon name in this field to see it appear.',
        link: {
          text: 'Visit Library >',
          url: 'https://fontawesome.com/icons?d=gallery&m=free'
        }
      }
    },
    operation: {
      type: 'string',
      default: 'link',
      options: ['link', 'save', 'discard', 'delete', 'create', 'run', 'download', 'send', 'load']
    },
    behavior: {
      type: 'string',
      default: 'none',
      options: ['back', 'none']
    },
    action: {
      type: 'string, function',
      default: 'http://www.insticator.com' // options: ['http://www.insticator.com', 'app/subpage', '#section', () => console.log('some action')]

    },
    badge: {
      type: 'string',
      default: '',
      options: ['', 'new', 'attention']
    },
    iconRight: {
      type: 'boolean',
      default: true,
      options: [false, true]
    },
    processing: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    handleClick: {
      type: 'function',
      default: function _default() {
        return console.log("clicked!");
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;